import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useIconProps } from '../useIconProps';

var Clear = function Clear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M5.48 10.49a.48.48 0 010-.679l1.827-1.827-1.81-1.81a.48.48 0 11.679-.68l1.81 1.811 1.832-1.832a.48.48 0 01.679.679L8.665 7.984l1.85 1.85a.48.48 0 11-.68.678l-1.849-1.85L6.16 10.49a.48.48 0 01-.679 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8A6 6 0 112 8a6 6 0 0112 0zm-1 0A5 5 0 113 8a5 5 0 0110 0z"
  }));
};

Clear.displayName = 'Clear';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Clear.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Clear;